<script>
    // Licensed under Gnu Public Licence version 2
    // Copyright (c) 2020 (original work) Open Assessment Technologies SA ;
    import ItemBlocks from '../../item/blocks/ItemBlocks.svelte';

    export let choice;
</script>

{#if choice.blockTree}
    <ItemBlocks blockTree={choice.blockTree} />
{:else}{choice.content}{/if}
